import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class Collapsible extends Component {
	constructor(props) {
		super(props);
		this.state = {
			opened: false,
		}
	}

	toggleCollapsiblePanel = (e) => {
		this.setState({ opened: !this.state.opened });
	}

	render = () => {
		return (
			<div>
				<div className="collapsible-container" onClick={this.toggleCollapsiblePanel}>
					<div className="collapsible-header">
						<div className="header-icon" id={this.props.collapsibleId}>
							<span className={`icon icon-small icon-arrow-down-small ${this.state.opened ? 'icon-open' : 'icon-close'}`}></span>
						</div>
						<div className="header-title">
							<h1 className="vx_text-3">{this.props.headerText}</h1>
						</div>
					</div>
				</div>
				<ReactCSSTransitionGroup
					transitionName="option"
					transitionAppear={true}
					transitionAppearTimeout={500}
					transitionEnterTimeout={500}
					transitionLeaveTimeout={300}
				>
					{
						this.state.opened &&
						<div className="collapsible-body">
							{this.props.children}
						</div>
					}
				</ReactCSSTransitionGroup>
			</div>
		)
	}
}

Collapsible.propTypes = {
	headerText: PropTypes.string,
	children: PropTypes.node,
	collapsibleId: PropTypes.string
}

export default Collapsible;



// WEBPACK FOOTER //
// ./buttons/components/collapsible/Collapsible.js